const verticalLinePlugin = {
    id: 'verticalLine',
    afterInit: (chart) => {
        chart.verticalLine = {x: 0, draw: false}
    },
    afterEvent: (chart, evt) => {
        const {chartArea: {top, bottom, left, right}} = chart;
        const x = chart.tooltip._active.length ? chart.tooltip._active[0].element.x : 0;

        if (x < left || x > right) {
            chart.verticalLine = {x, draw: false}
            chart.draw();
            return;
        }

        chart.verticalLine = {x, draw: true}
        chart.draw();
    },
    afterDatasetsDraw: (chart, _, opts) => {
        const {ctx, chartArea: {top, bottom}} = chart;
        const {x, draw} = chart.verticalLine || {x: 0, draw: false};

        if (!draw) return;

        ctx.lineWidth = opts.width || 0;

        ctx.strokeStyle = opts.color || 'black'

        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, bottom);
        ctx.lineTo(x, top);
        ctx.stroke();
        ctx.restore();
    }
};

export default verticalLinePlugin;
